import { SxProps, Theme } from '@mui/material';

export const menuItemStyles: SxProps<Theme> = {
	gap: '12px',

	'& >svg': {
		width: '24px',
		height: '24px',
	}
}
